// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/WebAssetTemplateEditor/styles.scss
// module id = 1077
// module chunks = 0